import React, {useReducer} from 'react'
import {darkModeReducer} from "./darkModeReducer";
import settingsWhite from "../settings/settingsWhite";

const DarkModeContext = React.createContext({'darkMode':false, 'settings': settingsWhite});

const withDarkModeContext = Component => {
    return props => {

        const [state, dispatch] = useReducer(darkModeReducer, {'darkMode':false, 'settings': settingsWhite})

        return (
            <DarkModeContext.Provider value={ { state, dispatch } }>
                <Component {...props}/>
            </DarkModeContext.Provider>
        )
    }
}

const DarkModeContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(darkModeReducer, {'darkMode':false, 'settings': settingsWhite})

    return (
        <DarkModeContext.Provider value={ { state, dispatch } }>
            {children}
        </DarkModeContext.Provider>
    )
}

export {withDarkModeContext, DarkModeContextProvider, DarkModeContext}
